<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"></loading>
        <loading :active.sync="loadingCAl" :can-cancel="false" :is-full-page="true"></loading>
        <Header/>

        <b-container fluid="">
            <b-row class="titulo">
                <b-col class="seccionTitulo">
                    <b-icon icon="people-fill"></b-icon>
                    <span>Horario clínica {{ datosBusqueda.clinica.nombre }}</span>
                </b-col>
                <b-col class="seccionCodigo">
                    <div>AG_01_CL</div>
                </b-col>
            </b-row>
        </b-container>

        <div class="mt-2 col-md-12"></div>

        <b-container fluid="">
            <b-row class="row-contenedor">

                <b-col cols="12">
                    <b-row>
                        <b-col cols="4">
                            <b-row>
                                <b-col cols="3">
                                    <label>Clínica:</label>
                                </b-col>
                                <b-col cols="9">
                                    <v-select style="width: 100%" :clearable="false" :options="listaClinicas"
                                              v-model="datosBusqueda.clinica.clinicaID"
                                              :reduce="(variable) => variable.id"
                                              label="nombre" placeholder="Selecciona una clínica"
                                              v-if="$localStorageService.can('CA_06_selec_clinica')"
                                              @input="actualizarNombreClinica(false)">
                                        <span slot="no-options">No hay clinicas disponibles</span>
                                    </v-select>
                                </b-col>
                            </b-row>
                        </b-col>

                        <b-col cols="2" align="left">
                            <b-button-group>
                                <b-button variant="outline-primary" @click="opcionesSillones()"
                                          v-if="clinicaEstaSeleccionada && $localStorageService.can('BO_05_crearhor')">
                                    <b-icon icon="plus-circle"></b-icon>
                                    Crear horario
                                </b-button>
                              <b-button variant="outline-primary" @click="buscarHorarios()">
                                <b-icon title="Refrescar" icon="arrow-repeat"></b-icon>
                              </b-button>
                            </b-button-group>
                        </b-col>

                        <b-col cols="4">
                          <b-form-datepicker labelNoDateSelected="Fecha"
                                             no-flip
                                             v-model="datosBusqueda.fechaActual" class="mb-2"
                                             in @click.native="seleccionarFechaCalendario" ></b-form-datepicker>
                        </b-col>

                    </b-row>

                    <div class="mt-2 col-md-12"></div>

                    <b-row>
                        <b-col>

                            <cal-clinica
                                    @seleccionarFecha="seleccionarFechaPorDiaSemana"
                                    @consultarDetalle="consultarDetalle"
                                    @mostrarLoader="mostrarLoader"
                                    ref="calClinicas"
                             />
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <b-modal v-model="modalAgregarHorario" id="agregarHorario" size="xl" :title="'Agregar rango de horario por sillón y día de la clínica '+ datosBusqueda.clinica.nombre" >

            <b-row>
                <b-col cols="6">
                    <label>Sillón</label>
                    <b-form-select v-model="form_sillon" :options="arraySillones"></b-form-select>
                </b-col>

                <b-col cols="6">
                    <b-row>
                        <b-col cols="8">
                            <b-form inline>
                                <b-form-checkbox v-model="lunes" :disabled="semanaCompleta" switch>
                                    <Strong>Lunes</Strong>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="martes" :disabled="semanaCompleta" switch>
                                    <Strong>Martes</Strong>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="miercoles" :disabled="semanaCompleta" switch>
                                    <Strong>Miércoles</Strong>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="jueves" :disabled="semanaCompleta" switch>
                                    <Strong>Jueves</Strong>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="viernes" :disabled="semanaCompleta" switch>
                                    <Strong>Viernes</Strong>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="sabado" :disabled="semanaCompleta" switch>
                                    <Strong>Sabado</Strong>
                                </b-form-checkbox>
                                <b-form-checkbox v-model="domingo" :disabled="semanaCompleta" switch>
                                    <Strong>Domingo</Strong>
                                </b-form-checkbox>
                            </b-form>
                        </b-col>
                        <b-col cols="4">
                            <b-form-checkbox v-model="semanaCompleta" @input="semanaCompletaTrue" switch>
                                <Strong>Semana completa</Strong>
                            </b-form-checkbox>

                            <div class="mt-2 col-md-12"></div>

                            <b-button variant="outline-primary" @click="limpiarDiasSemanaAgregarHorario"  size="sm"
                                      v-b-modal.agregarHorario v-if="clinicaEstaSeleccionada">Limpiar días
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col cols="6">
                    <label>Fecha inicial</label>
                    <b-form-datepicker v-model="agregar_FechaInicial" class="mb-2" placeholder="Elije una fecha"
                                       no-flip
                                       today-button reset-button close-button label-today-button="Hoy"
                                       label-reset-button="Limpiar" label-close-button="Cerrar"></b-form-datepicker>
                </b-col>

                <b-col cols="6">
                    <label>Fecha final</label>
                    <b-form-datepicker v-model="agregar_FechaFinal" class="mb-2" placeholder="Elije una fecha"
                                       no-flip
                                       today-button reset-button close-button label-today-button="Hoy"
                                       label-reset-button="Limpiar" label-close-button="Cerrar"></b-form-datepicker>
                </b-col>

                <b-col cols="6">
                    <label>Hora inicial</label>
                    <vue-timepicker v-model="agregar_HoraInicial" hide-disabled-items format="HH:mm"
                                    no-flip
                                    :minute-interval="15" :hour-range="[[7,23]]" close-on-complete></vue-timepicker>
                </b-col>

                <b-col cols="6">
                    <label>Hora final</label>
                    <vue-timepicker v-model="agregar_HoraFinal" hide-disabled-items format="HH:mm" :minute-interval="15"
                                    :hour-range="rangoHoraFinForm" :minute-range="rangoMinFinForm"
                                    close-on-complete></vue-timepicker>
                </b-col>
            </b-row>

            <div class="mt-2 col-md-12"></div>

            <b-row v-if="mostrarRespuesta">
                <b-col>
                    <b-table id="Pendientes" thead-tr-class="columnas" :items="this.respuesta " :fields="encabezados"
                             class="parrafos" responsive>
                        <template v-slot:cell(guardado)="data">
                            <b-badge :variant="data.item.guardado ? 'success' : 'danger' " size="lg">{{
                                data.item.guardado ? "Guardado Correctamente" : "Horario Ocupado" }}
                            </b-badge>
                        </template>
                        <template v-slot:cell(sillon)="data">
                            {{ data.item.sillon }}
                        </template>
                        <template v-slot:cell(lunes)="data">
                            <b-form-checkbox v-model="data.item.lunes" :class="data.item.lunes ? '' : 'sr-only' " switch
                                             disabled>
                                Lunes
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(martes)="data">
                            <b-form-checkbox v-model="data.item.martes" :class="data.item.martes ? '' : 'sr-only' "
                                             switch disabled>
                                Martes
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(miercoles)="data">
                            <b-form-checkbox v-model="data.item.miercoles"
                                             :class="data.item.miercoles ? '' : 'sr-only' " switch disabled>
                                Miércoles
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(jueves)="data">
                            <b-form-checkbox v-model="data.item.jueves" :class="data.item.jueves ? '' : 'sr-only' "
                                             switch disabled>
                                Jueves
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(viernes)="data">
                            <b-form-checkbox v-model="data.item.viernes" :class="data.item.viernes ? '' : 'sr-only' "
                                             switch disabled>
                                Viernes
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(sabado)="data">
                            <b-form-checkbox v-model="data.item.sabado" :class="data.item.sabado ? '' : 'sr-only' "
                                             switch disabled>
                                Sábado
                            </b-form-checkbox>
                        </template>
                        <template v-slot:cell(domingo)="data">
                            <b-form-checkbox v-model="data.item.domingo" :class="data.item.domingo ? '' : 'sr-only' "
                                             switch disabled>
                                Domingo
                            </b-form-checkbox>
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <template v-slot:modal-footer>
                <b-button variant="outline-primary" size="sm" @click="agregarHorario"
                          v-if="$localStorageService.can('BO_05_crearhor') ">Guardar
                </b-button>
                <b-button variant="outline-danger" size="sm" @click="modalAgregarHorario=false">Cerrar</b-button>
            </template>
        </b-modal>

        <b-modal v-model="showDetail" size="xl" :title="'Detalles del rango de horario por sillón y día de la clínica '+ datosBusqueda.clinica.nombre" >
            <b-row>
                <b-col cols="6">
                    <label>Sillón:</label>{{datosDetalle.sillon}}
                </b-col>

                <b-col cols="6">
                    <label>Día:</label>{{diaSemana(datosDetalle.dia)}}
                </b-col>

                <b-col cols="6">
                    <label>Fecha inicial:</label>
                    <b-form-datepicker v-model="actualizar_FechaInicial" class="mb-2" placeholder="Elije una fecha"
                                       no-flip
                                       today-button reset-button close-button label-today-button="Hoy"
                                       label-reset-button="Limpiar" label-close-button="Cerrar"
                                       :disabled="inactivarHorario"></b-form-datepicker>
                </b-col>

                <b-col cols="6">
                    <label>Fecha final:</label>
                    <b-form-datepicker v-model="actualizar_FechaFinal" class="mb-2" placeholder="Elije una fecha"
                                       no-flip
                                       today-button reset-button close-button label-today-button="Hoy"
                                       label-reset-button="Limpiar" label-close-button="Cerrar"
                                       :disabled="inactivarHorario"></b-form-datepicker>
                </b-col>

                <b-col cols="6">
                    <label>Hora inicial:</label>
                    <vue-timepicker v-model="actualizar_HoraInicial" class="mb-2" hide-disabled-items format="HH:mm"
                                    :minute-interval="1" :hour-range="[[7,23]]" close-on-complete
                                    :disabled="inactivarHorario"></vue-timepicker>
                </b-col>

                <b-col cols="6">
                    <label>Hora final:</label>
                    <vue-timepicker v-model="actualizar_HoraFinal" class="mb-2" hide-disabled-items format="HH:mm"
                                    :minute-interval="1" close-on-complete
                                    :disabled="inactivarHorario"></vue-timepicker>
                </b-col>

                <b-col cols="6">
                    <b-form-checkbox v-model="inactivarHorario" switch>
                        <strong>Inactivar Horario</strong>
                    </b-form-checkbox>
                </b-col>

            </b-row>

            <div class="mt-2 col-md-12"></div>

          <div v-if="horariosDoctorEnRango !== undefined && horariosDoctorEnRango !== null && horariosDoctorEnRango.length > 0">
            <b-alert variant="danger" show>HORARIOS OCUPADOS EN HORARIO CLINICA ORIGINAL</b-alert>
            <b-table striped hover :fields="encabezadosHorariosDoctorEnRango" :items="horariosDoctorEnRango">
              <template #cell(horaInicial)="data">
                <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
              </template>

              <template #cell(horaFinal)="data">
                <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
              </template>

              <template #cell()="data">
                <i>{{ data.value }}</i>
              </template>
            </b-table>
            <div class="mt-2 col-md-12"></div>
          </div>

          <div v-if="citasEnRango !== undefined && citasEnRango !== null && citasEnRango.length > 0">
            <b-alert variant="danger" show>CITAS OCUPADAS EN HORARIO ORIGINAL</b-alert>
            <b-table striped hover :fields="encabezadosCitasEnRango"  :items="citasEnRango">
              <template #cell(horaInicio)="data">
                <b class="text-info">{{ data.value | formatoHoraDeEntero  }}</b>
              </template>

              <template #cell(horaFin)="data">
                <b class="text-info">{{ data.value | formatoHoraDeEntero }}</b>
              </template>

              <template #cell()="data">
                <i>{{ data.value }}</i>
              </template>
            </b-table>
            <div class="mt-2 col-md-12"></div>
          </div>

            <b-row v-if="mostrarRespuesta && respuestaActualizar !== undefined && respuestaActualizar !== null">
                <b-col>
                    <b-badge :variant="respuestaActualizar.actualizado ? 'success' : 'danger' " size="lg">
                        <h5>{{ this.respuestaActualizar.mensaje}}</h5>
                    </b-badge>
                </b-col>

                <b-col v-if="respuestaActualizar.actualizado != true">

                        <h3>Citas Agendadas:</h3>
                        <b-table id="Pendientes" thead-tr-class="columnas" :items="this.respuestaActualizar.citas"
                                 :fields="encabezadosUpdateCitas" class="parrafos" responsive>
                            <template v-slot:cell(idPaciente)="data">
                                {{ data.item.idPaciente }}
                            </template>
                            <template v-slot:cell(nombrePaciente)="data">
                                {{ data.item.nombrePaciente }}
                            </template>
                            <template v-slot:cell(fechaCita)="data">
                                {{ data.item.fechaCita | formatoFecha }}
                            </template>
                            <template v-slot:cell(horaInicio)="data">
                                {{ data.item.horaInicio | formatoHora }}
                            </template>
                            <template v-slot:cell(horaFin)="data">
                                {{ data.item.horaFin | formatoHora }}
                            </template>
                            <template v-slot:cell(estatusCita)="data">
                                {{ data.item.estatusCita }}
                            </template>
                        </b-table>
                        <br/><br/>
                        <h3>Horario de doctores asignados:</h3>
                        <b-table id="Pendientes" thead-tr-class="columnas"
                                 :items="this.respuestaActualizar.horariosDoctores" :fields="encabezadosUpdateDoctores"
                                 class="parrafos" responsive>
                            <template v-slot:cell(nombreDoctor)="data">
                                {{ data.item.nombreDoctor }}
                            </template>
                            <template v-slot:cell(especialidad)="data">
                                {{ data.item.especialidad }}
                            </template>
                            <template v-slot:cell(dia)="data">
                                {{ diaSemana(data.item.dia) }}
                            </template>
                        <template v-slot:cell(fechaInicio)="data">
                            {{ data.item.fechaInicio | formatoFecha }}
                        </template>
                        <template v-slot:cell(fechaFin)="data">
                            {{ data.item.fechaFin | formatoFecha }}
                        </template>
                        <template v-slot:cell(horaInicio)="data">
                            {{ data.item.horaInicio | formatoHora }}
                        </template>
                        <template v-slot:cell(horaFin)="data">
                            {{ data.item.horaFin | formatoHora }}
                        </template>
                    </b-table>
                </b-col>
            </b-row>

            <template v-slot:modal-footer>
                <b-button variant="outline-primary" size="sm" @click="actualizarHorario"
                          v-if="$localStorageService.can('BO_05_actualizHorar') ">Actualizar
                </b-button>
                <b-button variant="outline-danger" size="sm" @click="showDetail = false">Cerrar</b-button>
            </template>

        </b-modal>

    </div>
</template>

<script>
    import Header from "../../components/Header.vue";

    export default {
        components: {
            Header,
        },
        data: () => ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            idUsuario: null,
            loading: false,
            loadingCAl: false,
            semana: {},
            numeroSillones: {
                type: Number,
                default: 5
            },
            datosBusqueda: {
                clinica: {
                    clinicaID: null,
                    nombre: '-'
                },
                clinicaNombre: '-',
                fechaInicio: undefined,
                fechaFin: undefined,
                fechaActual: new Date(),
                empleadoId: null,
            },

            listaClinicas: [],

            horariosDoctorEnRango: [],
            citasEnRango: [],
            encabezadosHorariosDoctorEnRango: [
              {label: 'Horario', key: 'idAgendaEmpleado', sortable: true, variant: 'danger'},
              {label: 'Doctor', key: 'nombreEmpleado', sortable: true, variant: 'danger'},
              {label: 'Periodicidad', key: 'nombrePeriodicidad', sortable: true, variant: 'danger'},
              {label: 'Fecha inicio', key: 'fechaInicialSinFormato', sortable: true, variant: 'danger'},
              {label: 'Fecha fin', key: 'fechaFinalSinFormato', sortable: true, variant: 'danger'},
              {label: 'Hora Inicio', key: 'horaInicial', sortable: true, variant: 'danger'},
              {label: 'Hora Fin', key: 'horaFinal', sortable: true, variant: 'danger'}
            ],
            encabezadosCitasEnRango: [
              {label: 'Cita', key: 'idCita', sortable: true, variant: 'danger'},
              {label: 'Paciente', key: 'nombrePaciente', sortable: true, variant: 'danger'},
              {label: 'Estatus', key: 'estatusCita', sortable: true, variant: 'danger'},
              {label: 'Sillon', key: 'sillon', sortable: true, variant: 'danger'},
              {label: 'Fecha', key: 'fechaCitaSinZona', sortable: true, variant: 'danger'},
              {label: 'Hora Inicio', key: 'horaInicio', sortable: true, variant: 'danger'},
              {label: 'Hora Fin', key: 'horaFin', sortable: true, variant: 'danger'}
            ],

            eventos: [],

            /* modal detalles*/
            datosDetalle: [],

            /* mostrar modal de crear horario */
            form_sillon: null,
            agregar_FechaInicial: null,
            agregar_FechaFinal: null,
            agregar_HoraInicial: {"HH": "07", "mm": "00"},
            agregar_HoraFinal: null,
            arraySillones: null,
            semanaCompleta: false,
            lunes: false,
            martes: false,
            miercoles: false,
            jueves: false,
            viernes: false,
            sabado: false,
            domingo: false,
            limpiarDias: false,
            respuesta: null,
            respuestaActualizar: [{
                actualizado: null,
                citas: [],
                horariosDoctores: [],
            }],
            inactivarHorario: false,
            mostrarRespuesta: false,
            actualizar_FechaInicial: null,
            actualizar_FechaFinal: null,
            actualizar_HoraInicial: null,
            actualizar_HoraFinal: null,

            encabezados: [
                {
                key: "guardado",
                label: "guardado",
                },
                {
                    key: "sillon",
                    label: "sillon",
                },
                {
                    key: "lunes",
                    label: "lunes",
                },
                {
                    key: "martes",
                    label: "martes",
                },
                {
                    key: "miercoles",
                    label: "miércoles",
                },
                {
                    key: "jueves",
                    label: "jueves",
                },
                {
                    key: "viernes",
                    label: "viernes",
                },
                {
                    key: "sabado",
                    label: "sabado",
                },
                {
                    key: "domingo",
                    label: "domingo",
                },
            ],

            encabezadosUpdateCitas: [
                {
                key: "idPaciente",
                label: "Id Paciente",
                },
                {
                    key: "nombrePaciente",
                    label: "Nombre Paciente",
                },
                {
                    key: "fechaCita",
                    label: "Fecha Cita",
                },
                {
                    key: "horaInicio",
                    label: "Hora Inicio",
                },
                {
                    key: "horaFin",
                    label: "Hora Fin",
                },
                {
                    key: "estatusCita",
                    label: "Hora Fin",
                }
            ],

            encabezadosUpdateDoctores: [
                {
                key: "especialidad",
                label: "especialidad",
                },
                {
                    key: "nombreDoctor",
                    label: "nombre doctor",
                },
                {
                    key: "dia",
                    label: "dia",
                },
                {
                    key: "fechaInicio",
                    label: "fechaInicio",
                },
                {
                    key: "fechaFin",
                    label: "fechaFin",
                },
                {
                    key: "horaFin",
                    label: "horaFin",
                }
            ],

            showDetail: false,
            modalAgregarHorario: false,
        }),
        methods: {

            llenarClinicas() {
                this.$http.get(this.$api + "catalogos/listaClinicas")
                    .then(response => {
                        if (response.status === 200) {
                            this.listaClinicas = response.data.data.map(it => {
                                return {
                                    id: it.idClinica,
                                    nombre: it.strNombre,
                                    numeroSillones: it.numeroSillones,
                                };
                            }).filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
                            this.actualizarNombreClinica(true);
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            },

            buscarHorarios() {

                this.eventos = Array();

                const idClinica = this.datosBusqueda.clinica.clinicaID;
                if (idClinica === undefined || idClinica === null || idClinica === 0) {
                    return;
                }

                this.loading = true;
                this.loadingCAl = true;

                const params = {
                  clinica: this.datosBusqueda.clinica.clinicaID,
                  fechaInicio: this.$moment(this.datosBusqueda.fechaInicio).utc().format('YYYY-MM-DD[T]HH:mm[:00Z]')
                }
                this.$http
                    .post(
                        this.$api +
                        "agendaclinica/horariosclinicaprocesado", params)
                    .then((response) => {

                        if (response.status === 200 && response.data.data !== undefined && response.data.data !== null) {
                            response.data.data.forEach(v => {

                                v.horaInicio = v.horaInicio.toString();
                                if (v.horaInicio.length < 4) {
                                  v.horaInicio = '0'+v.horaInicio;
                                }

                                v.horaFin = v.horaFin.toString();
                                if (v.horaFin.length < 4) {
                                  v.horaFin = '0'+v.horaFin;
                                }

                                const fechaEvento = this.$moment(v.fecha.split("T")[0]).format('YYYY/MM/DD');
                                const horaInicioEvento = v.horaInicio;

                                const pos = fechaEvento + '-' + horaInicioEvento + '-' + v.sillon;
                                if (v.horaInicio.toString().length === 4) {
                                  v.horaInicioCasilla = v.horaInicio.substr(0, 2) + ':' + v.horaInicio.substr(2, 3);
                                }
                                if (v.horaFin.toString().length === 4) {
                                  v.horaFinCasilla = v.horaFin.substr(0, 2) + ':' + v.horaFin.substr(2, 3);
                                }

                                this.eventos[pos] = v;

                            });
                        }
                    })
                    .catch((error) => {
                        this.loadingCAl = false;
                        console.error("No hay datos" + error);
                    })
                    .finally(() => {
                        this.loadingCAl = false;
                        if (this.$refs.calClinicas !== undefined) {
                            this.$refs.calClinicas.calcularSemana(this.datosBusqueda.fechaInicio, this.eventos, this.getNumeroSillonesClinica);
                        }
                        this.loading = false;
                    });

            },

            actualizarNombreClinica(inicializar) {
                if (this.listaClinicas !== undefined) {
                    const clinicaSelec = this.listaClinicas.find(it => it.id === this.datosBusqueda.clinica.clinicaID);
                    if (clinicaSelec !== undefined && clinicaSelec !== null) {
                        this.datosBusqueda.clinica.nombre = clinicaSelec.nombre;

                        if (inicializar) {
                            const fechaActual = new Date();
                            this.seleccionarFecha(fechaActual);
                        } else {
                            this.buscarHorarios();
                        }
                    }
                }
            },

            consultarDetalle(horarioClinica) {
                this.datosDetalle = horarioClinica;
                this.mostrarRespuesta = false;
                this.inactivarHorario = false;
                this.actualizar_FechaInicial = this.datosDetalle.fechaInicio;
                this.actualizar_FechaFinal = this.datosDetalle.fechaFin;
                this.actualizar_HoraInicial = this.datosDetalle.horaInicioCasilla;
                this.actualizar_HoraFinal = this.datosDetalle.horaFinCasilla;
                this.respuestaActualizar = [{
                    actualizado: null,
                    citas: [],
                    horariosDoctores: [],
                }];

                this.horariosDoctorEnRango = [];
                this.citasEnRango = [];

                this.showDetail=true;

            },

            mostrarLoader(bandera) {
                this.loading = bandera;
            },

            opcionesSillones() {
                this.limpiarFormularioAgregarHorario();
                this.arraySillones = [];
                const sillonesClinica = this.getNumeroSillonesClinica;

                let contador = 1;
                for (let i = 0; i < sillonesClinica; i++) {
                    this.arraySillones.push({
                        value: contador,
                        text: contador
                    });

                    contador++;
                }
              this.arraySillones.push({value: 100, text: '100 (E1)'});
              this.arraySillones.push({value: 101, text: '101 (E2)'});

                this.modalAgregarHorario=true;

            },

            semanaCompletaTrue() {
                if (this.semanaCompleta == true) {

                    this.lunes = true;
                    this.martes = true;
                    this.miercoles = true;
                    this.jueves = true;
                    this.viernes = true;
                    this.sabado = true;
                    this.domingo = true;

                } else {
                    this.lunes = false;
                    this.martes = false;
                    this.miercoles = false;
                    this.jueves = false;
                    this.viernes = false;
                    this.sabado = false;
                    this.domingo = false;
                }
            },

            limpiarDiasSemanaAgregarHorario() {
                this.semanaCompleta = false;
                this.lunes = false;
                this.martes = false;
                this.miercoles = false;
                this.jueves = false;
                this.viernes = false;
                this.sabado = false;
                this.domingo = false;

            },

            limpiarFormularioAgregarHorario() {
                this.form_sillon = null;
                this.semanaCompleta = false;
                this.lunes = false;
                this.martes = false;
                this.miercoles = false;
                this.jueves = false;
                this.viernes = false;
                this.sabado = false;
                this.domingo = false;
                this.mostrarRespuesta = false;
                this.agregar_FechaInicial = null;
                this.agregar_FechaFinal = null;
                this.agregar_HoraInicial = {"HH": "07", "mm": "00"};
                this.agregar_HoraFinal = null;
            },

            agregarHorario() {

                var errror = false;
                this.respuesta = null;
                if (this.form_sillon == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar un sillon",
                    });
                    return false;
                }

                if (this.lunes == false &&
                    this.martes == false &&
                    this.miercoles == false &&
                    this.jueves == false &&
                    this.viernes == false &&
                    this.sabado == false &&
                    this.domingo == false) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar un dia de la semana",
                    });
                    return false;
                }

                if (this.agregar_FechaInicial == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar la fecha inicial",
                    });
                    return false;
                }

                if (this.agregar_FechaFinal == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar la fecha final",
                    });
                    return false;
                }

                if (this.agregar_HoraInicial == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar la hora inicial",
                    });
                    return false;
                }

                if (this.agregar_HoraFinal == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar la hora final",
                    });
                    return false;
                }

                if (this.agregar_FechaInicial > this.agregar_FechaFinal) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "La fecha inicial no debe ser mayor a la fecha final",
                    });
                    return false;
                }

                if (this.agregar_HoraInicial > this.agregar_HoraFinal) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "La hora inicial no debe ser mayor a la hora final",
                    });
                    return false;
                }

                if (this.agregar_HoraInicial == this.agregar_HoraFinal) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "La hora inicial no debe ser igual a la hora final",
                    });
                    return false;
                }

                var fi = this.$moment(this.agregar_FechaInicial).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
                var ff = this.$moment(this.agregar_FechaFinal).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

                const hii = this.agregar_HoraInicial.HH + "" + this.agregar_HoraInicial.mm;
                const hff = this.agregar_HoraFinal.HH + "" + this.agregar_HoraFinal.mm;

                var datosGuardar = {};
                datosGuardar.idClinica = this.datosBusqueda.clinica.clinicaID;
                datosGuardar.sillon = this.form_sillon;
                datosGuardar.semanaCompleta = this.semanaCompleta;
                datosGuardar.lunes = this.lunes;
                datosGuardar.martes = this.martes;
                datosGuardar.miercoles = this.miercoles;
                datosGuardar.jueves = this.jueves;
                datosGuardar.viernes = this.viernes;
                datosGuardar.sabado = this.sabado;
                datosGuardar.domingo = this.domingo;
                datosGuardar.fechaInicio = fi;
                datosGuardar.fechaFin = ff;
                datosGuardar.horaInicio = hii;
                datosGuardar.horaFin = hff;
                datosGuardar.idUsuario = this.idUsuario;

                if (errror != true) {
                    this.loading = true;
                    this.$http.post(this.$api + "agendaclinica/registrarHorarioClinica", datosGuardar)
                        .then(response => {
                            if (response.status === 200) {
                                this.mostrarRespuesta = true;
                                this.$swal.fire({
                                    icon: 'success',
                                    title: 'El horario se registró con éxito'
                                });

                                this.buscarHorarios();
                                this.respuesta = response.data.data;
                            }
                        })
                        .catch(error => {

                            if (error.response) {
                                this.$swal.fire({
                                    icon: "error",
                                    title: "Aviso",
                                    text: error.response.data.message,
                                });
                            } else {
                                this.$swal.fire({
                                    icon: "error",
                                    title: "Aviso",
                                    text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente",
                                });
                            }

                            this.mostrarRespuesta = true;
                            this.buscarHorarios();
                            this.respuesta = error.response.data.data;

                        }).finally(() => this.loading = false)

                }

            },

            actualizarHorario() {

                this.mostrarRespuesta = false;

                this.horariosDoctorEnRango = [];
                this.citasEnRango = [];

                var errror = false;
                this.respuestaActualizar = [{
                    actualizado: null,
                    citas: [],
                    horariosDoctores: [],
                }];

                if (this.actualizar_FechaInicial == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar una fecha inicial",
                    });
                    return false;
                }

                if (this.actualizar_FechaFinal == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar una fecha final",
                    });
                    return false;
                }

                if (this.actualizar_HoraInicial == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar una hora inicial",
                    });
                    return false;
                }
                if (this.actualizar_HoraFinal == null) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de seleccionar una hora final",
                    });
                    return false;
                }

                if (this.actualizar_HoraInicial == '00:00:00') {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de agregar una hora valida en la hora inicial",
                    });
                    return false;
                }

                if (this.actualizar_HoraFinal == '00:00:00') {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "Por favor de agregar una hora valida en la hora final",
                    });
                    return false;
                }

                if (this.actualizar_FechaInicial > this.actualizar_FechaFinal) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "La fecha inicial no debe ser mayor a la fecha final",
                    });
                    return false;
                }

                if (this.actualizar_HoraInicial > this.actualizar_HoraFinal) {
                    errror = true;
                    this.$swal.fire({
                        icon: "error",
                        title: "Aviso",
                        text: "La hora inicial no debe ser mayor a la hora final",
                    });
                    return false;
                }

                const fi = this.$moment(this.datosDetalle.fechaInicio).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
                const ff = this.$moment(this.datosDetalle.fechaFin).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
                const fia = this.$moment(this.actualizar_FechaInicial).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
                const ffa = this.$moment(this.actualizar_FechaFinal).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

                const hi = this.datosDetalle.horaInicio;
                const hf = this.datosDetalle.horaFin;

                const arrayDeCadenasFIa = this.actualizar_HoraInicial.split(":");
                const hia = arrayDeCadenasFIa[0] + "" + arrayDeCadenasFIa[1];

                const arrayDeCadenasFFa = this.actualizar_HoraFinal.split(":");
                const hfa = arrayDeCadenasFFa[0] + "" + arrayDeCadenasFFa[1];

                const datosActualizar = {};
                datosActualizar.semanaCompleta = false; // campo requerido por eso lo agrego como nulo, aunque no lo uso.
                datosActualizar.idAgendaClinica = this.datosDetalle.idAgendaClinica;
                datosActualizar.idClinica = this.datosBusqueda.clinica.clinicaID;
                datosActualizar.sillon = this.datosDetalle.sillon;
                datosActualizar.idUsuario = this.idUsuario;
                datosActualizar.diaActualizar = this.datosDetalle.dia;
                datosActualizar.diaActualizar = this.datosDetalle.dia;
                datosActualizar.inactivarHorario = this.inactivarHorario;

                datosActualizar.fechaInicio = fi;
                datosActualizar.fechaFin = ff;
                datosActualizar.fechaInicioActualizar = fia;
                datosActualizar.fechaFinActualizar = ffa;

                datosActualizar.horaInicio = hi;
                datosActualizar.horaFin = hf;
                datosActualizar.horaInicioActualizar = hia;
                datosActualizar.horaFinActualizar = hfa;

                if (errror != true) {
                    this.loading = true;
                    this.$http.put(this.$api + "agendaclinica/actualizarHorarioClinica", datosActualizar)
                        .then(response => {
                            if (response.status === 200) {
                                this.mostrarRespuesta = true;
                                this.$swal.fire({
                                    icon: 'success',
                                    title: 'La solicitud se proceso con éxito.'
                                });

                                this.buscarHorarios();
                                this.respuestaActualizar = response.data.data.respuesta;
                            }
                        })
                        .catch(error => {

                            this.loading = false;

                            if (error.response) {
                                this.$swal.fire({
                                    icon: "error",
                                    title: "Aviso",
                                    text: error.response.data.message,
                                });
                            } else {
                                this.$swal.fire({
                                    icon: "error",
                                    title: "Aviso",
                                    text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente.",
                                });
                            }

                            this.mostrarRespuesta = true;
                            this.buscarHorarios();

                            this.respuestaActualizar = error.response.data.data.respuesta;
                            this.horariosDoctorEnRango = error.response.data.data.horariosDoctorEnRango;
                            this.citasEnRango = error.response.data.data.citasEnRango;

                        }).finally(() => this.loading = false)

                }

            },

            diaSemana(numeroDia) {

                var nombreDia = "";
                switch (numeroDia) {
                    case 1:
                        nombreDia = "Lunes";
                        break;
                    case 2:
                        nombreDia = "Martes";
                        break;
                    case 3:
                        nombreDia = "Mi\u00E9rcoles";
                        break;
                    case 4:
                        nombreDia = "Jueves";
                        break;
                    case 5:
                        nombreDia = "Viernes";
                        break;
                    case 6:
                        nombreDia = "Sabado";
                        break;
                    case 7:
                        nombreDia = "Domingo";
                        break;
                    default:
                        break;
                }

                return nombreDia;

            },

            seleccionarFechaPorDiaSemana(date) {

                this.datosBusqueda.fechaInicio = date;


                this.datosBusqueda.fechaFin = new Date();
                this.datosBusqueda.fechaFin.setDate(this.datosBusqueda.fechaInicio.getDate() + 7);
                this.buscarHorarios();
            },

            seleccionarFecha(date) {
                const fecha = new Date(date.toISOString());
                fecha.setHours(0);
                fecha.setMinutes(0);
                fecha.setMilliseconds(0);


                this.datosBusqueda.fechaInicio = new Date(fecha.toISOString());
                this.datosBusqueda.fechaInicio.setDate(fecha.getDate() - fecha.getDay());

                this.datosBusqueda.fechaFin = new Date(fecha.toISOString());
                this.datosBusqueda.fechaFin.setDate(fecha.getDate() + (7 - date.getDay()));

                this.buscarHorarios();
            },

            calcularNumeroSillones() {
                if (this.datosBusqueda.clinica !== null && this.datosBusqueda.clinica.clinicaID !== undefined && this.datosBusqueda.clinica.clinicaID > 0 && this.listaClinicas !== undefined && this.listaClinicas !== null) {
                    const clinica = this.listaClinicas.find(c => c.id === this.datosBusqueda.clinica.clinicaID);
                    if (clinica !== undefined) {
                        const sillones = this.listaClinicas.find(c => c.id === this.datosBusqueda.clinica.clinicaID).numeroSillones;
                        if (sillones !== undefined && sillones !== null && sillones > 0) {
                            return sillones;
                        }
                    }
                }
                return 1;
            },
          seleccionarFechaCalendario() {
            this.seleccionarFecha(new Date(this.datosBusqueda.fechaActual));
          },
        },

        created() {
          this.debug = this.$localStorageService.getDebug();
            if (this.$localStorageService.getIdEmpleado() !== undefined) {
                this.datosBusqueda.clinica.empleadoId = this.$localStorageService.getIdEmpleado();
            }
            if (this.$localStorageService.getIdClinica() !== undefined) {
                this.datosBusqueda.clinica.clinicaID = this.$localStorageService.getIdClinica();
            }

            this.fechaActual = new Date();
            this.llenarClinicas();
            this.idUsuario = this.$localStorageService.getIdUsuario();
        },
        watch: {
            rangoHoraFinForm: function () {
                this.agregar_HoraFinal = {
                    "HH": this.agregar_HoraInicial.HH,
                    "mm": "00"
                };
            }
        },
        computed: {
            clinicaEstaSeleccionada() {
                return this.datosBusqueda.clinica.clinicaID !== undefined
                    && this.datosBusqueda.clinica.clinicaID !== null
                    && this.datosBusqueda.clinica.clinicaID > 0;
            },
            clinicaId() {
                return this.datosBusqueda.clinica.clinicaID;
            },
            getNumeroSillonesClinica: function () {
                return this.calcularNumeroSillones();
            },
            rangoHoraFinForm: function () {
                if (this.agregar_HoraInicial !== null) {
                    return [
                        [this.agregar_HoraInicial.HH, 23]
                    ];
                }
                return [
                    [7, 23]
                ];
            },
            rangoMinFinForm: function () {
                if (this.agregar_HoraInicial !== null) {
                    return [
                        [this.agregar_HoraInicial.mm, 59]
                    ];
                }
                return [
                    [0, 59]
                ];
            },

        }

    };
</script>
